import { Component, Input, OnInit } from '@angular/core';
import { Place, PlaceImage } from '../models/place.model';
import { AppSettings } from '../app.settings';

@Component({
  selector: 'app-info-window-card',
  templateUrl: './info-window-card.component.html',
  styleUrls: ['./info-window-card.component.scss']
})
export class InfoWindowCardComponent implements OnInit {
  @Input()
  public place: Place;

  @Input()
  pluginUrl: any;

  @Input()
  mapComponent: any;

  public featuredImage: PlaceImage;
  detailUrl: string = AppSettings.DETAIL_URL;

  constructor() { }

  ngOnInit() {
    this.featuredImage = this.place.images[0];
  }

  // details(): Promise<boolean> {
  //   return this.router.navigate(['art', this.art.id]);
  // }


}
